import { Button, Notice, PageHead } from '@kovix/ui';
import { useNavigate } from '@tanstack/react-router';
import { useSession } from '@/app/auth/session.store';
import { MODULE_LABELS } from '@/shared/config/navigation';

export function AccessDeniedPage({
  capability,
  moduleCode,
}: {
  capability?: string | undefined;
  moduleCode?: string | undefined;
}) {
  const navigate = useNavigate();
  // KOVIX-2983/2989 (RJ-POP-07, RJ-PBL-06): ở phạm vi Platform người cấp quyền là Super Admin nền tảng (không phải Tenant Admin)
  const platformScope = useSession((s) => s.mode === 'platform') || !!capability?.startsWith('platform.');
  const moduleLabel = moduleCode ? (MODULE_LABELS[moduleCode] ?? moduleCode) : null;
  return (
    <div>
      <PageHead
        title="Không có quyền truy cập"
        subtitle="Vai trò hoặc gói dịch vụ hiện tại không cho phép mở chức năng này."
      />
      <Notice tone="warn" icon="🔒">
        {moduleLabel ? (
          <div>
            Module <b>{moduleLabel}</b> chưa được bật cho gói dịch vụ hoặc vai trò của bạn.
          </div>
        ) : null}
        {capability ? (
          <div>
            Cần quyền <code>{capability}</code>. Liên hệ {platformScope ? 'Super Admin nền tảng' : 'Tenant Admin'} để được
            cấp quyền phù hợp (quyền được kiểm ở máy chủ, không thể vượt qua bằng đường dẫn).
          </div>
        ) : null}
      </Notice>
      <div style={{ marginTop: 16, display: 'flex', gap: 10 }}>
        <Button variant="primary" onClick={() => navigate({ to: '/' })}>
          Về Trung tâm vận hành
        </Button>
        <Button onClick={() => window.history.back()}>Quay lại</Button>
      </div>
    </div>
  );
}
